import React, { useEffect } from 'react';

import { Link } from "react-router-dom";

function LoadingScreen({ LoadingAnimation, LoadingTitle, url, vsibilty, handlecloseloading }) {
  useEffect(() => {
    console.log(vsibilty);
  }, [vsibilty]);


  return (
    <div id="overlay">
      <div className="load-sec">
        <center>
           <div className="load-spinner"></div> {/* Updated class name */}
          <p className="loading-tile">{LoadingTitle}</p>
          <Link to={`${url}`}>
            <button className={`got-to-btn${vsibilty}`}>Go to Demo Catalogue</button>
          </Link>
          <p className={`got-to-p${vsibilty}`} onClick={handlecloseloading}>Cancel</p>
        </center>
      </div>
    </div>
  );
}

export default React.memo(LoadingScreen); // Memoized to prevent unnecessary re-renders
